import { Suspense } from 'react';

import { NOTIFICATION_ROUTER } from '~/constants/router';
import { CampaignDateFilter } from '~/domains/campaign/components/CampaignDateFilter';
import { useLinkComponent } from '~/hooks/mobileApp';

import { HomeCampaignDateTooltips } from './HomeCampaignDateTooltips';
import { HomeCampaignList } from './HomeCampaignList';

import { ChevronRightIcon, Metapo24X24Icon } from '~/assets/icons';

export function HomeCampaignSection() {
  const LinkComponent = useLinkComponent();

  return (
    <section className="flex flex-col gap-16 px-20 py-24">
      <div className="flex w-full items-center justify-between">
        <div className="flex flex-col gap-2">
          <div className="flex gap-4">
            <Metapo24X24Icon />
            <h3 className="typo-heading100">메시지로 받은 상품</h3>
          </div>
          <strong className="relative text-description typo-paragraph100-regular">
            메시지 속 상품 모아두었어요!
          </strong>
        </div>
        <LinkComponent href={NOTIFICATION_ROUTER.rootWithFilter('all')}>
          <p className="flex items-center text-primary-medium typo-paragraph100-regular">
            전체보기
            <ChevronRightIcon className="w-20 [&>path]:fill-blue-800" />
          </p>
        </LinkComponent>
      </div>
      <div>
        <HomeCampaignDateTooltips />
        <CampaignDateFilter />
      </div>
      <Suspense fallback={<div className="h-[240px] w-full" />}>
        <HomeCampaignList />
      </Suspense>
    </section>
  );
}
